const logUtilResult = () => {};

const describeThirdPartyNode = (node = {}) => ({
  id: node?.id ?? null,
  rowid: node?.rowid ?? null,
  socid: node?.socid ?? null,
  fk_soc: node?.fk_soc ?? null,
  parent: node?.parent ?? null,
  name: node?.name ?? node?.ref ?? node?.socname ?? null,
  email: node?.email ?? null,
  ref: node?.ref ?? null,
});

const deriveThirdPartyId = (node = {}) => {
  const candidate =
    node.id ??
    node.rowid ??
    node.socid ??
    node.fk_soc ??
    node.company_id ??
    node.ref ??
    node.name ??
    node.email ??
    node.parent;
  const result = candidate ? String(candidate) : "";
  logUtilResult("deriveThirdPartyId", { node: describeThirdPartyNode(node), result });
  return result;
};

const deriveThirdPartyName = (node = {}) => {
  const identifier = deriveThirdPartyId(node);
  const result =
    node.name ||
    node.ref ||
    node.socname ||
    (identifier ? `Thirdparty ${identifier}` : "Thirdparty");
  logUtilResult("deriveThirdPartyName", { node: describeThirdPartyNode(node), result });
  return result;
};

const findThirdPartyNodeBySoc = (nodes, fkSoc) => {
  if (!Array.isArray(nodes) || nodes.length === 0 || fkSoc === undefined || fkSoc === null) {
    logUtilResult("findThirdPartyNodeBySoc", {
      message: "Invalid inputs",
      fkSoc,
      nodesCount: Array.isArray(nodes) ? nodes.length : 0,
    });
    return null;
  }

  const target = String(fkSoc);
  const stack = [...nodes];

  while (stack.length > 0) {
    const current = stack.pop();
    const candidates = [
      current?.id,
      current?.rowid,
      current?.socid,
      current?.fk_soc,
      current?.company_id,
    ]
      .filter((value) => value !== undefined && value !== null)
      .map((value) => String(value));

    if (candidates.includes(target)) {
      const description = describeThirdPartyNode(current);
      logUtilResult("findThirdPartyNodeBySoc", { fkSoc: target, match: description });
      return current;
    }

    if (Array.isArray(current?.children) && current.children.length > 0) {
      stack.push(...current.children);
    }
  }

  logUtilResult("findThirdPartyNodeBySoc", {
    fkSoc: target,
    match: null,
    explored: nodes.length,
  });
  return null;
};

export {
  deriveThirdPartyId,
  deriveThirdPartyName,
  describeThirdPartyNode,
  findThirdPartyNodeBySoc,
};
